<!--公用弹出框-->
<template>
  <a-modal
    :title="name"
    :width="250"
    :footer="null"
    @cancel="cancel"
    :visible="visible"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
        <a-row :gutter="24">
          <div style="text-align: center;margin-bottom: 20px">{{msg}}</div>
        <a-col align="center"  :md="24" :sm="24">
          <a-button @click="handleSubmit" type="primary">确定</a-button>
          <a-button @click="cancel" style="margin-left: 10px">取消</a-button>
        </a-col>
        </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
  import { postAxios, getAxios } from '@/api/request'

  const formList = {
    id: ''
  }

  export default {
    name: 'advertDel',
    data () {
      return {
        // 验证组件
//        fieldRule,
        photo: '',
        canClick: true,
        name: '',
        mode: '',
        msg: '',
        formData: { ...formList },
        labelCol: {
          xs: { span: 36 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this) // 注册后，才能通过表单拉取数据
      }
    },
    methods: {
      del (record) {
        this.mode = 'del'
        this.name = '删除商品'
        this.visible = true
        this.msg = '确定删除该商品！'
        if (record) {
          this.formData = record
        }
      },
      putaway (record) {
        this.mode = 'putaway'
        this.name = '上架'
        this.visible = true
        this.msg = '确定将该广告上架！'
        if (record) {
          this.formData = record
        }
      },
      shelves (record) {
        this.mode = 'shelves'
        this.name = '下架'
        this.visible = true
        this.msg = '确定将该广告下架！'
        if (record) {
          this.formData = record
        }
      },
      refundMsg (record) {
        this.mode = 'refundMsg'
        this.name = '退款'
        this.visible = true
        this.msg = record.msg
      },
      resetPass (record) {
        this.mode = 'resetPass'
        this.name = '密码修改'
        this.visible = true
        this.msg = record.msg
      },
      errorMsg (record) {
        this.mode = 'resetPass'
        this.name = record.name
        this.visible = true
        this.msg = record.msg
      },

      handleSubmit () {
        this.confirmLoading = true
        this.form.validateFields((err, values) => { // 表单验证
          if (!err) {
            if (this.formData.id) {
              values.id = this.formData.id
            }
            if (this.mode === 'del') {
              postAxios('delGoods', values).then(res => {
                  console.log(res)
                  if (res.code === '000000') {
                    this.confirmLoading = false
                    this.cancel()
                    this.$emit('ok', '') // 成功回调
                  } else {
                    this.$message.error(res.msg)
                  }
              }).catch(err => {
                console.log(err)
                this.confirmLoading = false
              })
            } else if (this.mode === 'putaway') { // 下架
              values.del = true
              postAxios('shelvesAdvert', values).then(res => {
                console.log(res)
                if (res.code === '000000') {
                  this.confirmLoading = false
                  this.cancel()
                  this.$emit('ok', '') // 成功回调
                } else {
                  this.$message.error(res.msg)
                }
              }).catch(err => {
                console.log(err)
                this.confirmLoading = false
              })
            } else if (this.mode === 'shelves') { // 下架
              values.del = false
              postAxios('shelvesAdvert', values).then(res => {
                console.log(res)
                if (res.code === '000000') {
                  this.confirmLoading = false
                  this.cancel()
                  this.$emit('ok', '') // 成功回调
                } else {
                  this.$message.error(res.msg)
                }
              }).catch(err => {
                console.log(err)
                this.confirmLoading = false
              })
            }
            else {
              this.confirmLoading = false
              this.cancel()
            }
          } else {
            this.confirmLoading = false
            this.cancel()
          }
        })
      },
      cancel () {
        this.visible = false
        this.confirmLoading = false
        this.form.resetFields() // 清空表单
        this.formData = { ...formList }
      }

    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/common/commonAlert.vue